import React from 'react';

import {PublishableVersionStatus} from 'template-collectibles/publishing-ui/TemplatePublishingConstants';
import getTestProps from 'test/lib/cypress/getTestProps';

interface PublishingNoteViewBannerProps {
  onCreateDraft: () => void;
  publishingStatus: PublishableVersionStatus;
}

export default function PublishingNoteViewBanner({
  onCreateDraft,
  publishingStatus,
}: PublishingNoteViewBannerProps): JSX.Element {
  return (
    <span>
      Editing is disabled on {publishingStatus.toLowerCase()} versions. You can{' '}
      <a
        onClick={onCreateDraft}
        {...getTestProps({component: 'PublishingNoteViewBanner', element: 'createDraftLink'})}
      >
        create new draft
      </a>{' '}
      to make changes.
    </span>
  );
}
